export const firebaseFunctionHost =
  process.env["NODE_ENV"] === "production"
    ? "https://asia-northeast1-kaigi100-next-b1eb7.cloudfunctions.net/api"
    : `${process.env["NEXT_PUBLIC_FUNCTION_HOST"]}`;

export const firebaseCloudFunctionHost =
  process.env["NODE_ENV"] === "production"
    ? "asia-northeast1-kaigi100-next-b1eb7.cloudfunctions.net"
    : `${process.env["NEXT_PUBLIC_FIREBASE_CLOUD_FUNCTION_HOST"]}`;
